<template>
  <div class="d-flex align-items-center justify-content-between">
    <h1 class="mb-0">Benutzer</h1>

    <EditUserModal :index="0" :buttonStyle="0" @saved-benutzer="loadBenutzer" />
  </div>

  <hr class="my-2" />

  <!-- <EditBenutzerModal :index="0" /> -->

  <div v-if="benutzerStore.users.length === 0" class="alert alert-info mt-3">Es wurden noch keine Benutzer erstellt.</div>

  <div v-else-if="!loading && benutzerStore.users.length > 0" class="mt-3">
    <UserRow v-for="(user, index) in sortedUsers" :key="user.id" :user="user" :index="index" />
  </div>

  <!-- <pre>{{ benutzerStore.users }}</pre> -->
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted } from 'vue';
  import { useBenutzerStore } from '@/stores/benutzerStore';
  import { useCommonStore } from '@/stores/commonStore';

  import { User } from '@/models/BenutzerModels';

  import UserRow from '@/components/Benutzer/UserRow.vue';
  import EditUserModal from '@/components/Benutzer/EditUserModal.vue';
  //#endregion

  const benutzerStore = useBenutzerStore();
  const commonStore = useCommonStore();

  const loading = computed(() => commonStore.status.getBenutzerLoading);

  const sortedUsers = computed(() =>
    benutzerStore.users.slice().sort((a: User, b: User) => {
      const lastNameComparison = a.lastName.localeCompare(b.lastName);

      if (lastNameComparison == 0) {
        return a.firstName.localeCompare(b.firstName);
      }

      return lastNameComparison;
    })
  );

  async function loadBenutzer() {
    await benutzerStore.getAllRealmUsers('admin');
  }

  // const test = ref<any>(null);
  // async function getAllKeycloakRealmUsers() {
  //   ApiService.getAllKeycloakRealmUsers('admin').then((response) => {
  //     test.value = response.data;
  //     console.log('Keycloak Realm Users:', test.value);
  //   });
  // }

  onMounted(async () => {
    // await benutzerStore.getBenutzer();
    await loadBenutzer();
  });
</script>
